var map = {
	"./en/features.png": "6eq2",
	"./ja/features.png": "fysh",
	"./ko/features.png": "lmjQ",
	"./zh-CN/features.png": "BZVl",
	"./zh-TW/features.png": "QJJR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YvIC";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/features\.png$
// module id = YvIC
// module chunks = 1